import Model from './Model'

export default class CanonicalExercise extends Model {
  resource() {
    return 'canonical-exercises'
  }
}
